import { Link } from "react-router-dom";
import styled from "styled-components/macro";

export const FooterWrapper = styled.footer`
  width: 100%;
  padding: 30px 60px 40px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #000;
  background-color: #eeeff0;

  @media (max-width: 1319px) {
    padding: 26px 12px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    padding: 40px 26px;
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas:
    "logo nav"
    "info nav"
    "footer-bottom footer-bottom";
  column-gap: 24px;
  row-gap: 32px;
  width: 100%;
  max-width: 1320px;
  background-color: #eeeff0;

  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      "logo"
      "info"
      "nav"
      "footer-bottom";
    row-gap: 40px;
  }
`;

export const LogoSection = styled.div`
  grid-area: logo;
`;

export const InfoSection = styled.div`
  grid-area: info;
  display: flex;
  flex-direction: column;
  gap: 36px;

  @media (min-width: 768px) and (max-width: 1023px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    column-gap: 24px;
    align-items: start;
  }
`;

export const Logo = styled.img`
  display: block;
  width: 310px;
  max-width: 100%;

  @media (min-width: 768px) and (max-width: 1023px) {
    margin: 0 auto;
  }
`;

export const BlockSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const SectionTitle = styled.span`
  display: block;
  font-weight: 400;
  color: #A7A7A7;
  line-height: 22px;
  margin-bottom: 12px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ButtonsSection = styled.div`
  display: flex;

  @media (min-width: 768px) and (max-width: 1023px) {
    justify-content: flex-end;
  }
`;

export const NavigationSection = styled.div`
  grid-area: nav;
`;

export const LinksBlock = styled.div`
  display: flex;
  gap: 24px;

  @media (min-width: 768px) and (max-width: 1023px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 24px;
  }
`;

export const Contacts = styled.div`
  letter-spacing: -1%;
  line-height: 40px;
  min-height: 40px;
  min-width: 0;
  text-align: left;

  @media (min-width: 768px) and (max-width: 1023px) {
    min-height: auto;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 26px;
  }
`;

export const Copyright = styled(SectionTitle)`
  margin-bottom: 0;
  line-height: 40px;
  min-width: 0;
  text-align: left;

  @media (min-width: 768px) and (max-width: 1023px) {
    line-height: 1.5;
    text-align: center;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;

  @media (min-width: 768px) and (max-width: 1023px) {
    justify-content: center;
    margin-bottom: 14px;
  }
`;

export const StyledLink = styled(Link)`
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  text-decoration: none;
  color: black;
  
  &:hover {
    color: #1983ff;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #141414;
  text-decoration: none;
  transition: color 0.2s ease;

  svg {
    display: block;
    width: auto;
    height: 40px;
  }

  svg path {
    fill: currentColor;
    transition: fill 0.2s ease;
  }

  &:hover {
    color: #1983ff;
  }
`;

export const PolicyInfo = styled(StyledLink)`
  margin-bottom: 0;
`

export const LegalInfo = styled(SectionTitle)`
  line-height: 158%;
  margin-bottom: 0;
`;

export const BottomSection = styled.div`
  grid-area: footer-bottom;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  column-gap: 24px;
  margin-top: 8px;

  @media (min-width: 768px) and (max-width: 1023px) {
    display: flex;
    flex-direction: column;
    margin-top: 0;
  }
`;

export const BottomMetaSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-width: 0;
  width: 100%;

  ${SocialLinks} {
    justify-content: flex-end;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    flex-direction: column-reverse;
    gap: 14px;

    ${SocialLinks} {
      justify-content: center;
    }
  }
`;
